import { createContext, useContext, useEffect, useState } from "react";
import { api, adminApi, tokens } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [store, setStore] = useState(null); // null=checking, false=none, obj=logged
  const [admin, setAdmin] = useState(false);
  const [adminUser, setAdminUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const refreshAdmin = () => {
    if (!tokens.admin()) { setAdmin(false); setAdminUser(null); return; }
    setAdmin(true);
    adminApi.me().then(setAdminUser).catch((e) => { if (e.response?.status === 401) { tokens.clearAdmin(); setAdmin(false); setAdminUser(null); } });
  };

  useEffect(() => {
    refreshAdmin();
    if (!tokens.store()) { setStore(false); setLoading(false); return; }
    api.me()
      .then((s) => setStore(s))
      .catch(() => { tokens.clearStore(); setStore(false); })
      .finally(() => setLoading(false));
  }, []);

  const loginStore = async (code, pin) => {
    const data = await api.loginStore(code, pin);
    setStore(data.store);
    return data;
  };
  const loginAdmin = async (password, email) => {
    const d = await adminApi.login(password, email);
    setAdmin(true);
    setAdminUser({ ...d.user, urole: d.user.role });
    adminApi.me().then(setAdminUser).catch(() => {});
    return d;
  };
  const logoutStore = () => { tokens.clearStore(); setStore(false); };
  const logoutAdmin = () => { tokens.clearAdmin(); setAdmin(false); setAdminUser(null); };
  const can = (area, write = false) => !adminUser || (adminUser.perms?.[write ? "write" : "read"] || []).includes(area);

  return (
    <AuthContext.Provider value={{ store, admin, adminUser, can, refreshAdmin, loading, loginStore, loginAdmin, logoutStore, logoutAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
